const imp = () => import(/* webpackChunkName: "loadSprite_invoiceCloud_color"*/  "../sprite/loadSprite_invoiceCloud_color");

const loadMap_invoiceCloud_color: { [key: string]: () => Promise<any> } = {
  "Icon-Manual-input02": imp,
  "Icon-Check-input": imp,
  "Icon-Document-identification": imp,
  "Icon-My-invoice": imp,
  "Icon-My-email": imp,
}
export default loadMap_invoiceCloud_color;